// extracted by mini-css-extract-plugin
export default {"logoAffiliate":"LogoAffiliate-module__logoAffiliate-VDuU"};